export default {
  steps: {
    setup_fee: "Frais d'installation",
    business_info: 'Informations entreprise',
    create_preview: 'Créer un aperçu du contrat',
    preview: 'Aperçu du contrat',
    sign: 'Signer le contrat',
  },
  buttons: {
    next: 'Aperçu du contrat',
    save_and_continue: 'Enregistrer et continuer',
    update: "Mettre à jour l'aperçu",
    cancel: "Annuler l'actuel",
    skip: 'Ignorer la création du contrat',
  },
  create_preview: {
    header: 'Créer un aperçu du contrat',
    description: "Saisissez les coordonnées du destinataire. Vous pouvez encore les modifier avant l'envoi.",
  },
  sign: {
    update_notice: "Pour mettre à jour le contrat, annulez l'actuel et modifiez les détails.",
  },
  toasts: {
    failed_to_save_changes: "Impossible d'enregistrer les modifications",
  },
};
